module.exports = __webpack_public_path__ + "assets/img/Singapore-China.f6d25a4e.png";